"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLASHCARDS_TOPICS = exports.QUESTION_TOPICS = exports.TOPICS = exports.TOPIC = void 0;
const client_1 = require("@apollo/client");
exports.TOPIC = (0, client_1.gql) `
  query Topic($topicId: Int!) {
    restricted {
      topic(id: $topicId) {
        id
        name
        entitlement {
          id
          name
          index
        }
        totalQuestions
        correctQuestions
        incorrectQuestions
        totalCards
        greenCards
        yellowCards
        redCards
        dailyFeedCards
        typeId
      }
    }
  }
`;
// TODO: rename filter->typeId
exports.TOPICS = (0, client_1.gql) `
  query Topics($filter: Int!, $order: Int) {
    restricted {
      topics(filter: $filter, order: $order) {
        id
        name
        totalQuestions
        correctQuestions
        incorrectQuestions
        totalCards
        greenCards
        yellowCards
        redCards
        typeId
        entitlement {
          id
          name
          index
        }
        concepts {
          id
          name
          topicId
          totalQuestions
          totalCards
        }
      }
    }
  }
`;
exports.QUESTION_TOPICS = (0, client_1.gql) `
  query Question_Topics($filter: Int!) {
    restricted {
      topics(filter: $filter) {
        id
        name
        totalQuestions
        correctQuestions
        incorrectQuestions
        typeId
        entitlement {
          id
          name
          index
        }
        concepts {
          id
          name
          topicId
          totalQuestions
          correctQuestions
          incorrectQuestions
          entitlement {
            id
            index
            name
          }
        }
      }
    }
  }
`;
exports.FLASHCARDS_TOPICS = (0, client_1.gql) `
  query Flashcard_Topics($filter: Int!) {
    restricted {
      topics(filter: $filter) {
        id
        name
        totalCards
        greenCards
        yellowCards
        redCards
        typeId
        entitlement {
          id
          name
          index
        }
        concepts {
          id
          name
          topicId
          totalCards
          greenCards
          yellowCards
          redCards
        }
      }
    }
  }
`;
